var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _g, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleOkOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 141,
    viewBox: "0 0 163 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 74.5622V59.3218H132.481V62.7971H126.191V24.7266H114.098V39.711H110.469V32.2283H101.033V68.7198H87.7268V55.8271H79.384V27.8734H69.0873V46.5091H59.4098V86.6561H51.9119V67.1062H44.1694V54.527H35.945V44.8688L26.7687 49.7093V75.5488H17.0911V70.2188H4.16406V118.209L154.634 118.282V74.5622H141.917Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 31.1719H71.4453V34.6246H74.4581V31.1719Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 36.9609H71.4453V40.4137H74.4581V36.9609Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 42.7578H71.4453V46.2106H74.4581V42.7578Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 48.5469H71.4453V51.9996H74.4581V48.5469Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 54.3359H71.4453V57.7887H74.4581V54.3359Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 60.125H71.4453V63.5778H74.4581V60.125Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 65.9141H71.4453V69.3668H74.4581V65.9141Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4581 71.7109H71.4453V75.1637H74.4581V71.7109Z",
    fill: "#FAFAFA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 26.5469H116.703V29.9996H119.716V26.5469Z",
    fill: "#FAFAFA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 32.3359H116.703V35.7887H119.716V32.3359Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 38.1328H116.703V41.5856H119.716V38.1328Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 43.9141H116.703V47.3668H119.716V43.9141Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 49.7031H116.703V53.1559H119.716V49.7031Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 55.5H116.703V58.9528H119.716V55.5Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 61.2969H116.703V64.7496H119.716V61.2969Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 67.0781H116.703V70.5309H119.716V67.0781Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1509 118.238V62.7109H49.1641V118.232L61.1509 118.238Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 64.4766H50.0781V67.4741H51.531V64.4766Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 64.4766H52.9766V67.4741H54.4294V64.4766Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 64.4766H55.8906V67.4741H57.3435V64.4766Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 64.4766H58.7891V67.4741H60.242V64.4766Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 69.5H50.0781V72.4976H51.531V69.5Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 69.5H52.9766V72.4976H54.4294V69.5Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 69.5H55.8906V72.4976H57.3435V69.5Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 69.5H58.7891V72.4976H60.242V69.5Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 74.5234H50.0781V77.521H51.531V74.5234Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 74.5234H52.9766V77.521H54.4294V74.5234Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 74.5234H55.8906V77.521H57.3435V74.5234Z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 74.5234H58.7891V77.521H60.242V74.5234Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 79.5547H50.0781V82.5523H51.531V79.5547Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 79.5547H52.9766V82.5523H54.4294V79.5547Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 79.5547H55.8906V82.5523H57.3435V79.5547Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 79.5547H58.7891V82.5523H60.242V79.5547Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 84.5703H50.0781V87.5679H51.531V84.5703Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 84.5703H52.9766V87.5679H54.4294V84.5703Z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 84.5703H55.8906V87.5679H57.3435V84.5703Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 84.5703H58.7891V87.5679H60.242V84.5703Z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 89.6016H50.0781V92.5991H51.531V89.6016Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 89.6016H52.9766V92.5991H54.4294V89.6016Z",
    fill: "#FAFAFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 89.6016H55.8906V92.5991H57.3435V89.6016Z",
    fill: "#FAFAFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 89.6016H58.7891V92.5991H60.242V89.6016Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 94.6172H50.0781V97.6148H51.531V94.6172Z",
    fill: "#FAFAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 94.6172H52.9766V97.6148H54.4294V94.6172Z",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 94.6172H55.8906V97.6148H57.3435V94.6172Z",
    fill: "#FAFAFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 94.6172H58.7891V97.6148H60.242V94.6172Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.531 99.6484H50.0781V102.646H51.531V99.6484Z",
    fill: "#FAFAFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4294 99.6484H52.9766V102.646H54.4294V99.6484Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3435 99.6484H55.8906V102.646H57.3435V99.6484Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60.242 99.6484H58.7891V102.646H60.242V99.6484Z",
    fill: "#FAFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M102.798 118.26V56.3047H77.9453V118.278C77.9453 118.278 102.608 118.285 102.798 118.26Z",
    fill: "#E6E6E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 58.3516H79.8047V61.8043H82.8175V58.3516Z",
    fill: "#E0E0E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 58.3516H85.8438V61.8043H88.8566V58.3516Z",
    fill: "#E0E0E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 58.3516H91.8672V61.8043H94.88V58.3516Z",
    fill: "#E0E0E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 58.3516H97.8984V61.8043H100.911V58.3516Z",
    fill: "#E0E0E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 64.1484H79.8047V67.6012H82.8175V64.1484Z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 64.1484H85.8438V67.6012H88.8566V64.1484Z",
    fill: "#E0E0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 64.1484H91.8672V67.6012H94.88V64.1484Z",
    fill: "#E0E0E0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 64.1484H97.8984V67.6012H100.911V64.1484Z",
    fill: "#E0E0E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 69.9375H79.8047V73.3903H82.8175V69.9375Z",
    fill: "#E0E0E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 69.9375H85.8438V73.3903H88.8566V69.9375Z",
    fill: "#E0E0E0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 69.9375H91.8672V73.3903H94.88V69.9375Z",
    fill: "#E0E0E0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 69.9375H97.8984V73.3903H100.911V69.9375Z",
    fill: "#E0E0E0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 75.7266H79.8047V79.1793H82.8175V75.7266Z",
    fill: "#E0E0E0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 75.7266H85.8438V79.1793H88.8566V75.7266Z",
    fill: "#E0E0E0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 75.7266H91.8672V79.1793H94.88V75.7266Z",
    fill: "#E0E0E0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 75.7266H97.8984V79.1793H100.911V75.7266Z",
    fill: "#E0E0E0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 81.5234H79.8047V84.9762H82.8175V81.5234Z",
    fill: "#E0E0E0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 81.5234H85.8438V84.9762H88.8566V81.5234Z",
    fill: "#E0E0E0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 81.5234H91.8672V84.9762H94.88V81.5234Z",
    fill: "#E0E0E0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 81.5234H97.8984V84.9762H100.911V81.5234Z",
    fill: "#E0E0E0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 87.3047H79.8047V90.7574H82.8175V87.3047Z",
    fill: "#E0E0E0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 87.3047H85.8438V90.7574H88.8566V87.3047Z",
    fill: "#E0E0E0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 87.3047H91.8672V90.7574H94.88V87.3047Z",
    fill: "#E0E0E0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 87.3047H97.8984V90.7574H100.911V87.3047Z",
    fill: "#E0E0E0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 93.1016H79.8047V96.5543H82.8175V93.1016Z",
    fill: "#E0E0E0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 93.1016H85.8438V96.5543H88.8566V93.1016Z",
    fill: "#E0E0E0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 93.1016H91.8672V96.5543H94.88V93.1016Z",
    fill: "#E0E0E0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 93.1016H97.8984V96.5543H100.911V93.1016Z",
    fill: "#E0E0E0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8175 98.8906H79.8047V102.343H82.8175V98.8906Z",
    fill: "#E0E0E0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8566 98.8906H85.8438V102.343H88.8566V98.8906Z",
    fill: "#E0E0E0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88 98.8906H91.8672V102.343H94.88V98.8906Z",
    fill: "#E0E0E0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 98.8906H97.8984V102.343H100.911V98.8906Z",
    fill: "#E0E0E0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.797 118.221V51.9609H34.5156V118.274C37.7695 118.193 44.797 118.221 44.797 118.221Z",
    fill: "#E6E6E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 53.1953H36.0312V56.6481H39.0441V53.1953Z",
    fill: "#FAFAFA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 58.9844H36.0312V62.4371H39.0441V58.9844Z",
    fill: "#FAFAFA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 64.7734H36.0312V68.2262H39.0441V64.7734Z",
    fill: "#FAFAFA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 70.5547H36.0312V74.0074H39.0441V70.5547Z",
    fill: "#FAFAFA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 76.3516H36.0312V79.8043H39.0441V76.3516Z",
    fill: "#FAFAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 82.1484H36.0312V85.6012H39.0441V82.1484Z",
    fill: "#FAFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 87.9297H36.0312V91.3825H39.0441V87.9297Z",
    fill: "#FAFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 93.7266H36.0312V97.1793H39.0441V93.7266Z",
    fill: "#FAFAFA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 53.1953H40.0703V56.6481H43.0831V53.1953Z",
    fill: "#FAFAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 58.9844H40.0703V62.4371H43.0831V58.9844Z",
    fill: "#FAFAFA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 64.7734H40.0703V68.2262H43.0831V64.7734Z",
    fill: "#FAFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 70.5547H40.0703V74.0074H43.0831V70.5547Z",
    fill: "#FAFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 76.3516H40.0703V79.8043H43.0831V76.3516Z",
    fill: "#FAFAFA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 82.1484H40.0703V85.6012H43.0831V82.1484Z",
    fill: "#FAFAFA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 87.9297H40.0703V91.3825H43.0831V87.9297Z",
    fill: "#FAFAFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 93.7266H40.0703V97.1793H43.0831V93.7266Z",
    fill: "#FAFAFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M143.279 53.1641H125.133V118.295H143.279V53.1641Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 55.8594H127.828V59.3121H133.147V55.8594Z",
    fill: "#FAFAFA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 61.6484H127.828V65.1012H133.147V61.6484Z",
    fill: "#FAFAFA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 67.4297H127.828V70.8824H133.147V67.4297Z",
    fill: "#FAFAFA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 73.2266H127.828V76.6793H133.147V73.2266Z",
    fill: "#FAFAFA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 79.0156H127.828V82.4684H133.147V79.0156Z",
    fill: "#FAFAFA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 84.8047H127.828V88.2574H133.147V84.8047Z",
    fill: "#FAFAFA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 90.6016H127.828V94.0543H133.147V90.6016Z",
    fill: "#FAFAFA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M133.147 96.3828H127.828V99.8356H133.147V96.3828Z",
    fill: "#FAFAFA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 55.8594H134.938V59.3121H140.256V55.8594Z",
    fill: "#FAFAFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 61.6484H134.938V65.1012H140.256V61.6484Z",
    fill: "#FAFAFA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 67.4297H134.938V70.8824H140.256V67.4297Z",
    fill: "#FAFAFA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 73.2266H134.938V76.6793H140.256V73.2266Z",
    fill: "#FAFAFA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 79.0156H134.938V82.4684H140.256V79.0156Z",
    fill: "#FAFAFA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 84.8047H134.938V88.2574H140.256V84.8047Z",
    fill: "#FAFAFA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 90.6016H134.938V94.0543H140.256V90.6016Z",
    fill: "#FAFAFA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 96.3828H134.938V99.8356H140.256V96.3828Z",
    fill: "#FAFAFA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M113.266 118.267V69.9375H105.352V118.263L113.266 118.267Z",
    fill: "#E0E0E0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 71.4609H105.945V74.0341H106.905V71.4609Z",
    fill: "#FAFAFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 71.4609H107.867V74.0341H108.827V71.4609Z",
    fill: "#FAFAFA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 71.4609H109.781V74.0341H110.741V71.4609Z",
    fill: "#FAFAFA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 71.4609H111.703V74.0341H112.663V71.4609Z",
    fill: "#FAFAFA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 75.7812H105.945V78.3545H106.905V75.7812Z",
    fill: "#FAFAFA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 75.7812H107.867V78.3545H108.827V75.7812Z",
    fill: "#FAFAFA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 75.7812H109.781V78.3545H110.741V75.7812Z",
    fill: "#FAFAFA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 75.7812H111.703V78.3545H112.663V75.7812Z",
    fill: "#FAFAFA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 80.1016H105.945V82.6748H106.905V80.1016Z",
    fill: "#FAFAFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 80.1016H107.867V82.6748H108.827V80.1016Z",
    fill: "#FAFAFA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 80.1016H109.781V82.6748H110.741V80.1016Z",
    fill: "#FAFAFA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 80.1016H111.703V82.6748H112.663V80.1016Z",
    fill: "#FAFAFA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 84.4219H105.945V86.9951H106.905V84.4219Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 84.4219H107.867V86.9951H108.827V84.4219Z",
    fill: "#FAFAFA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 84.4219H109.781V86.9951H110.741V84.4219Z",
    fill: "#FAFAFA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 84.4219H111.703V86.9951H112.663V84.4219Z",
    fill: "#FAFAFA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 88.7344H105.945V91.3076H106.905V88.7344Z",
    fill: "#FAFAFA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 88.7344H107.867V91.3076H108.827V88.7344Z",
    fill: "#FAFAFA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 88.7344H109.781V91.3076H110.741V88.7344Z",
    fill: "#FAFAFA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 88.7344H111.703V91.3076H112.663V88.7344Z",
    fill: "#FAFAFA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 93.0547H105.945V95.6279H106.905V93.0547Z",
    fill: "#FAFAFA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 93.0547H107.867V95.6279H108.827V93.0547Z",
    fill: "#FAFAFA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 93.0547H109.781V95.6279H110.741V93.0547Z",
    fill: "#FAFAFA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 93.0547H111.703V95.6279H112.663V93.0547Z",
    fill: "#FAFAFA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 97.375H105.945V99.9482H106.905V97.375Z",
    fill: "#FAFAFA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 97.375H107.867V99.9482H108.827V97.375Z",
    fill: "#FAFAFA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 97.375H109.781V99.9482H110.741V97.375Z",
    fill: "#FAFAFA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 97.375H111.703V99.9482H112.663V97.375Z",
    fill: "#FAFAFA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M106.905 101.695H105.945V104.269H106.905V101.695Z",
    fill: "#FAFAFA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 101.695H107.867V104.269H108.827V101.695Z",
    fill: "#FAFAFA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 101.695H109.781V104.269H110.741V101.695Z",
    fill: "#FAFAFA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 101.695H111.703V104.269H112.663V101.695Z",
    fill: "#FAFAFA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4328 118.278V77.0938H14.2734V118.21L35.4328 118.278Z",
    fill: "#FAFAFA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 78.375H15.875V80.5353H18.4406V78.375Z",
    fill: "#E0E0E0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 78.375H21.0078V80.5353H23.5734V78.375Z",
    fill: "#E0E0E0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 78.375H26.1328V80.5353H28.6984V78.375Z",
    fill: "#E0E0E0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 78.375H31.2578V80.5353H33.8234V78.375Z",
    fill: "#E0E0E0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 81.9922H15.875V84.1525H18.4406V81.9922Z",
    fill: "#E0E0E0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 81.9922H21.0078V84.1525H23.5734V81.9922Z",
    fill: "#E0E0E0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 81.9922H26.1328V84.1525H28.6984V81.9922Z",
    fill: "#E0E0E0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 81.9922H31.2578V84.1525H33.8234V81.9922Z",
    fill: "#E0E0E0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 85.6172H15.875V87.7775H18.4406V85.6172Z",
    fill: "#E0E0E0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 85.6172H21.0078V87.7775H23.5734V85.6172Z",
    fill: "#E0E0E0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 85.6172H26.1328V87.7775H28.6984V85.6172Z",
    fill: "#E0E0E0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 85.6172H31.2578V87.7775H33.8234V85.6172Z",
    fill: "#E0E0E0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 89.2422H15.875V91.4025H18.4406V89.2422Z",
    fill: "#E0E0E0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 89.2422H21.0078V91.4025H23.5734V89.2422Z",
    fill: "#E0E0E0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 89.2422H26.1328V91.4025H28.6984V89.2422Z",
    fill: "#E0E0E0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 89.2422H31.2578V91.4025H33.8234V89.2422Z",
    fill: "#E0E0E0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 92.8594H15.875V95.0197H18.4406V92.8594Z",
    fill: "#E0E0E0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 92.8594H21.0078V95.0197H23.5734V92.8594Z",
    fill: "#E0E0E0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 92.8594H26.1328V95.0197H28.6984V92.8594Z",
    fill: "#E0E0E0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 92.8594H31.2578V95.0197H33.8234V92.8594Z",
    fill: "#E0E0E0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 96.4766H15.875V98.6368H18.4406V96.4766Z",
    fill: "#E0E0E0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 96.4766H21.0078V98.6368H23.5734V96.4766Z",
    fill: "#E0E0E0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 96.4766H26.1328V98.6368H28.6984V96.4766Z",
    fill: "#E0E0E0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 96.4766H31.2578V98.6368H33.8234V96.4766Z",
    fill: "#E0E0E0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4406 100.094H15.875V102.254H18.4406V100.094Z",
    fill: "#E0E0E0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 100.094H21.0078V102.254H23.5734V100.094Z",
    fill: "#E0E0E0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6984 100.094H26.1328V102.254H28.6984V100.094Z",
    fill: "#E0E0E0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8234 100.094H31.2578V102.254H33.8234V100.094Z",
    fill: "#E0E0E0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2453 112.245C26.6158 111.652 25.2785 113.944 25.2785 113.944C25.2785 113.944 26.718 108.952 25.275 108.935C23.832 108.918 23.7598 113.194 23.7598 113.194C23.7598 113.194 23.2964 104.694 21.4201 105.366C19.5441 106.038 22.2822 113.625 22.2822 113.625C22.2822 113.625 19.8557 108.231 18.9257 109.292C17.9956 110.352 21.0615 114.864 21.0615 114.864C21.0615 114.864 18.8221 113.417 18.9673 114.449C19.1121 115.481 23.9676 118.179 23.9676 118.179C25.5218 116.338 27.8749 112.837 27.2453 112.245Z",
    fill: "#E6E6E6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9732 118.224C23.9732 118.224 23.2115 114.591 22.7734 112.117",
    stroke: "#E0E0E0",
    strokeWidth: 0.158821,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4759 115.819L21.9922 113.977",
    stroke: "#E0E0E0",
    strokeWidth: 0.158821,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M148.013 113.24C147.554 112.508 145.681 114.387 145.681 114.387C145.681 114.387 148.336 109.921 146.944 109.54C145.552 109.159 144.402 113.277 144.402 113.277C144.402 113.277 146.103 104.936 144.117 105.112C142.132 105.288 142.863 113.321 142.863 113.321C142.863 113.321 141.88 107.489 140.712 108.28C139.544 109.071 141.369 114.211 141.369 114.211C141.369 114.211 139.568 112.245 139.448 113.28C139.327 114.315 143.343 118.153 143.343 118.153C145.311 116.764 148.473 113.972 148.013 113.24Z",
    fill: "#E0E0E0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M143.344 118.196C143.344 118.196 143.525 114.488 143.727 111.984",
    stroke: "#E0E0E0",
    strokeWidth: 0.158821,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M143.462 115.743L142.492 113.586",
    stroke: "#E0E0E0",
    strokeWidth: 0.158821,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M102.04 12.8846C101.559 12.5212 100.857 12.4799 100.337 12.7849C99.646 11.3895 97.7214 10.7736 96.3489 11.5086C95.9909 10.0049 94.5091 8.84898 92.9635 8.8674C91.4179 8.88583 89.9643 10.0773 89.6426 11.5893C89.5914 11.8297 89.5578 12.0927 89.3856 12.2684C89.1064 12.5536 88.6404 12.4577 88.2424 12.4269C86.9906 12.3294 85.7311 13.208 85.3906 14.4166L102.63 14.3537C102.781 13.7702 102.521 13.2483 102.04 12.8846Z",
    fill: "#E0E0E0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M151.29 35.8687C150.809 35.5053 150.107 35.464 149.587 35.7689C148.896 34.3735 146.971 33.7576 145.599 34.493C145.241 32.9893 143.759 31.8334 142.214 31.8518C140.668 31.8705 139.214 33.0617 138.893 34.5736C138.841 34.8138 138.807 35.0771 138.636 35.2528C138.356 35.538 137.89 35.4421 137.492 35.4113C136.241 35.3137 134.981 36.1923 134.641 37.401L151.879 37.3384C152.031 36.7539 151.771 36.2321 151.29 35.8687Z",
    fill: "#F0F0F0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M137.159 17.7685C136.757 17.4652 136.171 17.4306 135.737 17.685C135.16 16.5199 133.554 16.0056 132.407 16.6196C132.109 15.364 130.871 14.399 129.581 14.4142C128.29 14.4298 127.076 15.4243 126.808 16.687C126.765 16.8877 126.737 17.1072 126.593 17.254C126.36 17.4922 125.971 17.4121 125.639 17.3861C124.594 17.3045 123.542 18.0382 123.258 19.0474L137.652 18.9949C137.778 18.508 137.561 18.0722 137.159 17.7685Z",
    fill: "#F5F5F5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0731 11.0888C55.6713 10.7852 55.0853 10.7509 54.651 11.0053C54.0745 9.8402 52.4676 9.32594 51.3215 9.93994C51.0226 8.6843 49.7854 7.71931 48.4948 7.73455C47.2043 7.75012 45.9906 8.74465 45.7218 10.0073C45.6793 10.208 45.651 10.4275 45.5074 10.5743C45.2743 10.8125 44.8852 10.7324 44.5529 10.7064C43.5076 10.6248 42.4558 11.3588 42.1719 12.3677L56.5658 12.3153C56.6919 11.828 56.4749 11.3922 56.0731 11.0888Z",
    fill: "#F5F5F5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6067 28.8484C39.8923 28.3088 38.8498 28.2475 38.0773 28.7001C37.0517 26.6278 34.1939 25.713 32.1559 26.8051C31.6242 24.572 29.4239 22.8555 27.1286 22.8831C24.8333 22.9108 22.6749 24.6797 22.1972 26.9248C22.1213 27.2815 22.0711 27.6725 21.8157 27.933C21.4012 28.3564 20.7091 28.2144 20.1179 28.1684C18.2591 28.0232 16.3885 29.3284 15.8828 31.1231L41.4828 31.03C41.707 30.1632 41.3211 29.3881 40.6067 28.8484Z",
    fill: "#F0F0F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M141.017 98.8897H83.6042C82.5776 98.8897 81.7422 98.0543 81.7422 97.0277V13.4011C81.7422 12.3745 82.5776 11.5391 83.6042 11.5391H141.017C142.043 11.5391 142.879 12.3741 142.879 13.4011V97.0274C142.879 98.0543 142.043 98.8897 141.017 98.8897ZM83.6042 11.6185C82.6211 11.6185 81.8216 12.4183 81.8216 13.4011V97.0274C81.8216 98.0105 82.6214 98.81 83.6042 98.81H141.017C142 98.81 142.799 98.0102 142.799 97.0274V13.4011C142.799 12.4183 141.999 11.6185 141.017 11.6185H83.6042Z",
    fill: "#E0E0E0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7903 98.8897H17.3776C16.351 98.8897 15.5156 98.0543 15.5156 97.0277V13.4011C15.5156 12.3745 16.3507 11.5391 17.3776 11.5391H74.7903C75.8169 11.5391 76.6523 12.3741 76.6523 13.4011V97.0274C76.6523 98.0543 75.8169 98.8897 74.7903 98.8897ZM17.3776 11.6185C16.3949 11.6185 15.595 12.4183 15.595 13.4011V97.0274C15.595 98.0105 16.3949 98.81 17.3776 98.81H74.7903C75.7734 98.81 76.5729 98.0102 76.5729 97.0274V13.4011C76.5729 12.4183 75.7731 11.6185 74.7903 11.6185H17.3776Z",
    fill: "#E0E0E0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M158.821 118.266H0V118.345H158.821V118.266Z",
    fill: "#E0E0E0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5154 122.82H16.4141V122.9H21.5154V122.82Z",
    fill: "#E0E0E0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1127 121.953H54.1094V122.033H71.1127V121.953Z",
    fill: "#E0E0E0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3504 125.766H21.8359V125.845H33.3504V125.766Z",
    fill: "#E0E0E0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M133.906 121.914H120.188V121.993H133.906V121.914Z",
    fill: "#E0E0E0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M138.745 121.914H136.734V121.993H138.745V121.914Z",
    fill: "#E0E0E0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M117.555 123.883H100.438V123.962H117.555V123.883Z",
    fill: "#E0E0E0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M143.314 127.235C143.314 128.585 115.282 129.68 80.7037 129.68C46.1255 129.68 18.0938 128.585 18.0938 127.235C18.0938 125.884 46.125 124.789 80.7037 124.789C115.282 124.79 143.314 125.884 143.314 127.235Z",
    fill: "#EEEEEE"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M109.555 68.2188C110.534 68.1379 111.02 68.3094 111.419 68.9135",
    stroke: "#111111",
    strokeWidth: 0.688775,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M109.844 67.0469C111.068 66.9316 112.224 67.3589 112.727 68.1119",
    stroke: "#111111",
    strokeWidth: 0.688775,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M110.602 65.7812C112.003 65.6407 113.33 66.1417 113.874 67.0176C114.011 67.2393 114.103 67.489 114.06 67.7534",
    stroke: "#111111",
    strokeWidth: 0.688775,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M113.492 113.735L111.702 115.219C111.16 115.669 110.437 115.835 109.753 115.668L99.4864 113.16L102.933 109.055L113.492 113.735Z",
    fill: "#454545"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6328 63.1562V65.2051C67.6328 67.4124 66.3106 69.403 64.275 70.2573C61.3998 71.464 57.7017 73.0057 57.5748 73.0057C57.3667 73.0057 53.1029 68.5338 53.1029 68.5338L60.0027 63.1562H67.6328Z",
    fill: "#454545"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2633 51H70.9978C71.7713 51 72.3984 51.6272 72.3984 52.4007V55.3087C72.3984 55.7366 72.2764 56.1557 72.0469 56.517L69.7301 60.1592C69.157 61.0604 68.2575 61.7046 67.2201 61.958L63.5176 62.8615L59.51 61.1235L64.2119 51.0004L69.2633 51Z",
    fill: "#2E2E2E"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2295 55.5547H62.1719V52.7457H72.2295V55.5547Z",
    fill: "#454545"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5864 61.7919L57.4214 59.4476L53.209 58.898C51.7485 58.7077 51.2066 56.8746 52.3288 55.9209L55.7618 53.0028C57.2828 51.71 59.2145 51 61.2108 51H69.2656C69.2656 52.6965 68.1293 54.1824 66.4922 54.6269L63.1696 55.5289L65.0208 56.6859C65.8731 57.2189 66.0396 58.3912 65.3692 59.1405L62.9954 61.7923L55.5864 61.7919Z",
    fill: "#51ACED"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2615 112.658L57.294 117.055C58.2214 118.401 59.751 119.204 61.3852 119.204H92.3917C93.678 119.204 94.9142 118.705 95.8404 117.812L101.758 112.109L54.2615 112.658Z",
    fill: "#2E2E2E"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7059 127.002C28.0003 127.002 20.943 119.945 20.943 111.239C20.943 102.534 28.0003 95.4766 36.7059 95.4766C45.4115 95.4766 52.4688 102.534 52.4688 111.239C52.4688 119.945 45.4115 127.002 36.7059 127.002Z",
    fill: "#494949"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7056 119.206C32.3059 119.206 28.7393 115.639 28.7393 111.24C28.7393 106.84 32.3059 103.273 36.7056 103.273C41.1052 103.273 44.6719 106.84 44.6719 111.24C44.6719 115.639 41.1052 119.206 36.7056 119.206Z",
    fill: "#B9B9B9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7024 117.4C33.2977 117.4 30.5377 114.64 30.5377 111.235C30.5377 107.83 33.2977 105.07 36.7024 105.07C40.1071 105.07 42.8672 107.83 42.8672 111.235C42.8672 114.64 40.1071 117.4 36.7024 117.4Z",
    fill: "#6E6E6E"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M133.042 127.002C124.336 127.002 117.279 119.945 117.279 111.239C117.279 102.534 124.336 95.4766 133.042 95.4766C141.747 95.4766 148.805 102.534 148.805 111.239C148.805 119.945 141.747 127.002 133.042 127.002Z",
    fill: "#494949"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M133.042 119.206C128.642 119.206 125.075 115.639 125.075 111.24C125.075 106.84 128.642 103.273 133.042 103.273C137.441 103.273 141.008 106.84 141.008 111.24C141.008 115.639 137.441 119.206 133.042 119.206Z",
    fill: "#B9B9B9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M133.046 117.4C129.641 117.4 126.881 114.64 126.881 111.235C126.881 107.83 129.641 105.07 133.046 105.07C136.451 105.07 139.211 107.83 139.211 111.235C139.211 114.64 136.451 117.4 133.046 117.4Z",
    fill: "#6E6E6E"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3291 113.504C35.3871 113.111 34.9418 112.029 35.335 111.087L38.3307 103.906L41.7422 105.33L38.7465 112.51C38.3537 113.452 37.2715 113.897 36.3291 113.504Z",
    fill: "#E9EBE7"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8166 107.459L36.7656 105.352L42.5518 91.4813L47.6027 93.5884L41.8166 107.459Z",
    fill: "#2E2E2E"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0005 104.076C19.0005 104.076 22.9022 90 40.3098 90L46.3125 98.1247L43.274 102.045C42.2811 103.327 40.7511 104.076 39.1298 104.076H19.0005Z",
    fill: "#51ACED"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M32.076 91.2422L35.4062 104.083",
    stroke: "#F6F8F5",
    strokeWidth: 0.404114,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M120.775 74.125H133.037C134.269 74.125 135.194 75.2505 134.954 76.4588L132.92 86.743C132.623 88.2411 131.663 89.5238 130.31 90.2301L122.191 94.4689L120.775 74.125Z",
    fill: "#2E2E2E"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M132.62 77.2437L131.165 84.6014C130.945 85.7115 131.795 86.7452 132.926 86.7452L134.961 76.4609H133.573C133.109 76.4609 132.71 76.7887 132.62 77.2437Z",
    fill: "#EA613B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M120.389 93.875L133.645 107.195C135.992 109.553 136.201 113.296 134.13 115.9C132.434 118.035 129.593 118.896 126.997 118.065L104.676 110.915L120.389 93.875Z",
    fill: "#2E2E2E"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0453 101.758L58.7852 102.382V107.896H94.4062L87.0453 101.758Z",
    fill: "#454545"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3767 61.4922L60.5618 63.1567L56.2959 70.6478L57.7103 71.4067C59.2896 72.2541 59.8913 74.2157 59.0593 75.8031L56.3307 81.0072C55.4546 82.6787 55.337 84.6439 56.0082 86.4074C57.9956 91.6278 62.0703 102.744 62.0703 106.127L42.8741 86.5181L58.3767 61.4922Z",
    fill: "#2E2E2E"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0355 101.753L93.4343 107.891L101.758 98.0069V83.8047H87.0355L90.6956 91.1814C91.524 92.8512 91.4206 94.8321 90.4228 96.4066L87.0355 101.753Z",
    fill: "#2E2E2E"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M131.252 70.4848C131.703 72.9054 130.303 75.2889 127.969 76.0741L98.6398 85.9417H87.8589C86.6473 85.9417 85.4988 85.4018 84.7258 84.4695L84.1164 83.7345C83.5813 83.0891 83.5975 82.1499 84.1543 81.5232L91.2231 73.5682C92.1526 72.5219 93.5395 72.003 94.9276 72.1821L99.8004 72.8109C103.656 73.3083 107.561 73.2744 111.407 72.7098L130.453 69.9138C130.829 69.8588 131.182 70.1106 131.252 70.4848Z",
    fill: "#454545"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8272 80.9828L48.2305 66.3729C52.8782 60.4179 61.3133 59.0172 67.6368 63.1497L63.2619 64.7597C58.9953 66.3301 55.4358 69.3828 53.2338 73.3604L50.3969 78.485C47.4756 83.7619 48.182 90.3049 52.1617 94.8371L60.4238 104.246C61.4705 105.437 62.9794 106.12 64.5652 106.12H89.4771C91.1882 106.12 92.8026 105.325 93.846 103.969L97.1234 99.7086C97.9268 98.664 98.0727 97.2557 97.5 96.0688L95.4576 91.8349C95.0677 91.0263 95.043 90.0895 95.3906 89.2615L96.5257 86.556C98.7875 81.1655 103.615 77.2791 109.364 76.2199L120.299 74.205C120.903 74.0939 121.525 74.1367 122.108 74.3299L126.47 75.7762C127.808 76.22 128.711 77.4707 128.711 78.8798V86.0193C128.711 86.8316 128.409 87.6147 127.863 88.2161L103.63 114.929C102.408 116.276 100.674 117.044 98.8558 117.044H60.7786C58.7435 117.044 56.828 116.083 55.6112 114.452L36.7383 89.1512C34.9234 86.7196 34.9602 83.3748 36.8272 80.9828Z",
    fill: "#F6F8F5"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M71.04 117.07H63.2188V116.392H71.04V117.07Z",
    fill: "#D7D9D6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2978 117.07H73.4766V116.392H81.2978V117.07Z",
    fill: "#D7D9D6"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5712 117.07H83.75V116.392H91.5712V117.07Z",
    fill: "#D7D9D6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2516 112.398H84.513L86.3125 114.413H59.5614L60.2516 112.398Z",
    fill: "#51ACED"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6455 74.7891L49.7969 79.6736",
    stroke: "#E9EBE7",
    strokeWidth: 0.404114,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2036 105.734L100.867 116.723",
    stroke: "#E9EBE7",
    strokeWidth: 0.404114,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5688 104.44L111.305 91.5078L104.158 96.0343C102.75 96.9254 101.024 97.1569 99.4322 96.6687L97.4953 96.0747C98.0679 97.2616 97.9221 98.6699 97.1187 99.7145L93.8413 103.975C92.7979 105.331 91.1839 106.126 89.4724 106.126H95.7621C97.212 106.127 98.5945 105.514 99.5688 104.44Z",
    fill: "#E9EBE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3876 106.115C65.3102 106.768 66.4179 107.132 67.5688 107.132H92.4808C94.1918 107.132 95.8062 106.337 96.8492 104.981L100.127 100.72C100.93 99.6754 101.076 98.2675 100.503 97.0802L98.4608 92.8463C98.0709 92.0376 98.0462 91.1005 98.3938 90.2729L99.5289 87.5673C101.791 82.1769 106.618 78.2905 112.367 77.2313L123.302 75.2164C123.906 75.1053 124.529 75.1481 125.111 75.3413L126.562 75.8226C126.528 75.81 126.497 75.7919 126.462 75.7801L122.1 74.3338C121.517 74.1407 120.895 74.0974 120.291 74.2089L109.356 76.2239C103.607 77.283 98.7797 81.1694 96.5179 86.5599L95.3827 89.2654C95.0352 90.0935 95.0598 91.0302 95.4498 91.8388L97.4922 96.0727C98.0648 97.2596 97.9189 98.6679 97.1155 99.7122L93.8382 103.973C92.7948 105.329 91.1807 106.124 89.4697 106.124H64.5577C64.5007 106.124 64.4446 106.117 64.3876 106.115Z",
    fill: "#454545"
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M119.079 72.8306V74.7917C119.079 75.1166 119.343 75.3801 119.668 75.3801H121.353C121.398 75.3801 121.443 75.3749 121.487 75.3648L132.126 72.8746C132.977 72.6754 133.522 71.8429 133.363 70.9834C133.318 70.7356 133.086 70.5663 132.837 70.5974L119.596 72.2466C119.301 72.283 119.079 72.5335 119.079 72.8306Z",
    fill: "#3B3B3B"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5391 105.734L58.7751 116.723",
    stroke: "#E9EBE7",
    strokeWidth: 0.404114,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M112.596 108.688C115.707 108.198 118.309 106.061 119.396 103.105L120.492 100.125L127.609 107.276C128.498 108.17 128.833 109.509 128.371 110.682C127.753 112.252 126.036 112.994 124.525 112.509L112.596 108.688Z",
    fill: "#363636"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6328 54.1547C73.6328 54.9306 73.004 55.5594 72.2281 55.5594C71.4522 55.5594 70.8234 54.9306 70.8234 54.1547C70.8234 53.3788 71.4522 52.75 72.2281 52.75C73.004 52.75 73.6328 53.3788 73.6328 54.1547Z",
    fill: "#3D3D3D"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8594 51L59.1854 54.9171C58.6451 55.7087 57.7487 56.1819 56.7902 56.1819H52.0818",
    stroke: "#F6F8F5",
    strokeWidth: 0.404114,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M108.145 109.953C108.179 109.916 107.819 108.568 107.539 107.541C107.343 106.822 107.527 106.052 108.026 105.499L117.787 94.6767C118.243 94.1703 118.909 93.9056 119.589 93.9602L122.445 94.1897L108.145 109.953Z",
    fill: "#51ACED"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7354 101.638C54.3067 101.991 53.673 101.93 53.3194 101.501L52.0861 100.005C51.7329 99.5762 51.7939 98.9426 52.2223 98.589C52.651 98.2358 53.2847 98.2968 53.6383 98.7256L54.8716 100.222C55.2252 100.651 55.1642 101.285 54.7354 101.638Z",
    fill: "#EA613B"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M110.703 114.414C110.703 114.635 110.525 114.813 110.304 114.813C110.084 114.813 109.905 114.635 109.905 114.414C109.905 114.194 110.084 114.016 110.304 114.016C110.525 114.016 110.703 114.194 110.703 114.414Z",
    fill: "#2E2E2E"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M113.974 102.069L114.695 102.727L110.212 107.65L109.49 106.993L113.974 102.069Z",
    fill: "#494949"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M120.06 95.3976L120.781 96.0547L116.298 100.978L115.576 100.321L120.06 95.3976Z",
    fill: "#494949"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M112.064 88.6661C110.091 86.6932 110.091 83.4943 112.064 81.5214C114.037 79.5484 117.236 79.5484 119.209 81.5214C121.182 83.4943 121.182 86.6932 119.209 88.6661C117.236 90.6391 114.037 90.6391 112.064 88.6661Z",
    fill: "#E9EBE7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M115.483 81.2812L119.008 85.8314H115.995L117.149 88.9073L112.616 83.9728L115.812 83.8451L115.483 81.2812Z",
    fill: "#27C872"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8972 68.0781L36.8222 80.9863C38.2815 81.9154 40.207 81.5864 41.2747 80.2254L46.3799 73.7175C47.6464 72.1031 47.8488 69.8962 46.8972 68.0781Z",
    fill: "#D7D9D6"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M91.927 112.398H86.8481L88.6477 114.413H93.7266L91.927 112.398Z",
    fill: "#51ACED"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3359 87.5156C31.6502 87.1161 32.066 86.9878 32.9767 87.0352",
    stroke: "#111111",
    strokeWidth: 0.505204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0312 87.0234C30.4068 86.5193 31.4199 86.2202 32.5569 86.2775",
    stroke: "#111111",
    strokeWidth: 0.505204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7812 86.3203C29.2006 85.7402 30.3762 85.4008 31.6817 85.4828C32.0121 85.5036 32.3573 85.5512 32.6641 85.6548",
    stroke: "#111111",
    strokeWidth: 0.505204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M109.192 45.2735C112.198 40.102 110.441 33.4734 105.27 30.468C100.098 27.4626 93.4689 29.2193 90.464 34.3907C88.144 38.3831 88.6718 43.2378 91.408 46.6296L90.8803 49.8392L94.2365 49.0983C94.2883 49.1292 94.3349 49.1659 94.3873 49.1962C99.5582 52.2016 106.187 50.4455 109.192 45.2735Z",
    fill: "#4BA434"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11263_73103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.541 35.5859L98.959 41.627L96.25 38.9199L95 40.1699L99.166 44.3359L105 36.8359L103.541 35.5859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11263_73103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(95 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleOkOff);
export default __webpack_public_path__ + "static/media/vehicle-ok-off.4e9332ee99340a173d775e235fadf567.svg";
export { ForwardRef as ReactComponent };